<template>
  <d-navbar-nav class="flex-row" :key="ComponentKey">
    <li class="nav-item border-left border-right dropdown notifications">
      <a
        class="nav-link nav-link-icon text-center"
        v-on:click="ToggleDropdown('notifications-collapse')"
      >
        <div class="nav-link-icon__wrapper">
          <i class="material-icons">&#xE7F4;</i>
          <d-badge
            pill
            theme="danger"
            v-if="TotalUnreadNotifications > 0 "
          >{{TotalUnreadNotifications}}</d-badge>
        </div>
      </a>
      <b-collapse
        id="notifications-collapse"
        class="dropdown-menu dropdown-menu-small"
        v-on:click="ToggleDropdown('notifications-collapse')"
      >
        <template v-for="(notification, index) in Notifications">
          <template v-if="!notification.IsRead">
            <d-dropdown-item
              :href="notification.Link"
              v-bind:key="'notification-' + index"
              v-on:click="ToggleDropdown('notifications-collapse')"
            >
              <div class="notification__icon-wrapper">
                <div class="notification__icon">
                  <i class="material-icons">{{notification.Icon}}</i>
                  <!-- You can find ICONS here https://material.io/resources/icons/ -->
                </div>
              </div>
              <div class="notification__content">
                <span class="notification__category">{{notification.Category}}</span>
                <p v-html="notification.Description"></p>
              </div>
            </d-dropdown-item>
          </template>
        </template>
        <d-dropdown-item
          v-if="TotalUnreadNotifications > 0"
          class="notification__all text-center"
          v-on:click="ToggleDropdown('notifications-collapse')"
          v-on:click.stop.native="MarkAllAsReaded"
        >{{TotalUnreadNotifications > 1 ? 'Marcar todas como lidas' : 'Marcar como lida'}}</d-dropdown-item>
        <d-dropdown-item
          v-else
          style="height: 4rem"
          v-on:click="ToggleDropdown('notifications-collapse')"
          class="notification__all text-center pt-4"
        >
          Nenhuma notificação
          <i class="material-icons">insert_emoticon</i>
        </d-dropdown-item>
      </b-collapse>
    </li>
    <li class="nav-item border-left dropdown" v-on:click="ToggleDropdown('user-actions-collapse')">
      <a class="nav-link dropdown-toggle text-nowrap px-3">
        <img
          class="user-avatar rounded-circle mr-2"
          id="imgUserNav"
          :src="User.PictureUrl"
          alt="User Avatar"
        />
        <div class="user-info d-inline-block">
          <span class="d-none d-md-block user-name no-select">{{User.Name}}</span>
          <span class="d-none d-md-block company-name no-select">{{User.Email}}&nbsp;</span>
        </div>
      </a>
      <b-collapse id="user-actions-collapse" class="dropdown-menu dropdown-menu-small">
        <b-dropdown-item to="/user-profile">
          <i class="material-icons">&#xE7FD;</i> Minha Conta
        </b-dropdown-item>
        <b-dropdown-item to="/change-password">
          <i class="material-icons">&#xe899;</i> Alterar Senha
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item
          href="#"
          class="text-danger"
          :class="[loginOut ? 'text-center': '']"
          :disabled="loginOut"
          v-on:click.stop="Logoff()
        "
        >
          <template v-if="!loginOut">
            <i class="material-icons text-danger">&#xE879;</i> Logout
          </template>
          <template v-else>
            Saindo
            <b-spinner class="ml-2" small v-if="loginOut"></b-spinner>
          </template>
        </b-dropdown-item>
      </b-collapse>
    </li>
  </d-navbar-nav>
</template>

<script>
export default {
  data: function() {
    return {
      ComponentKey: 0,
      isFirstClick: null,
      LastOpenedCollapse: null,
      loginOut: false,
      Notifications: [
        {
          Category: "Recebimentos",
          Description:
            'O pagamento das comiss\u00F5es est\u00E1 <b style="font-weight: bold">bloqueado</b>. Para regularizar envie a(s) nota(s) de servi\u00E7o pendente(s) atrav\u00E9s do menu <mark>Administra\u00E7\u00E3o > Notas de Servi\u00E7o</mark>.',
          Icon: "money_off",
          Link: "/administration/note-extracts?add-note=true",
          IsRead: true,
          IsPermanent: true
        }
      ],
      User: {
        Name: "",
        PictureUrl: "",
        Email: ""
      }
    };
  },
  computed: {
    TotalUnreadNotifications() {
      let unreadList = this.Notifications.filter(elm => {
        return elm.IsRead == false;
      });
      return unreadList.length;
    }
  },
  created() {
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (isJustShown) {
        if (this.LastOpenedCollapse != null) {
          // If there's some colapse opened, close it first.
          this.$root.$emit("bv::toggle::collapse", this.LastOpenedCollapse);
        }
        this.LastOpenedCollapse = collapseId;
        this.isFirstClick = true;
      } else {
        if (this.LastOpenedCollapse == collapseId) {
          this.LastOpenedCollapse = null;
        }
      }
    });

    this.$root.$on("PageClick", () => {
      if (this.LastOpenedCollapse != null && this.isFirstClick == false) {
        this.$root.$emit("bv::toggle::collapse", this.LastOpenedCollapse);
      }
      this.isFirstClick = this.isFirstClick ? false : null;
    });

    this.$root.$on("UpdateUserInfoHeader", () => {
      this.GetUserData();
    });
  },
  beforeMount() {
    let partner = this.$getPartner();

    let markedAsReaded = sessionStorage.getItem("NotificationIsReaded");

    if (partner != null) {
      if (
        partner.IsEnabled == false &&
        (markedAsReaded == "false" || markedAsReaded == null)
      ) {
        this.Notifications[0].IsRead = false; // Set notification as not readed.
      }
    }
  },
  mounted() {
    this.GetUserData();
    if (this.$profileCode() != "1") this.Notifications = [];
  },
  methods: {
    GetUserData() {
      if (this.$getUserPartner()) this.User = this.$getUserPartner();

      if (!this.User.PictureUrl)
        this.User.PictureUrl = require("@/assets/images/avatars/user2.png");
      else
        this.User.PictureUrl = this.User.PictureUrl + `?${Math.random()}`;

      if (!this.User.Name) this.User.Name = "Usuário Safe2Pay";
      if (!this.User.Email) this.User.Email = "usuario@safe2pay.com.br";

      this.ComponentKey += 1;
    },
    Logoff() {
      this.loginOut = true;
      this.$store
        .dispatch("Logoff", { token: this.$getTokenAuth() })
        .then(() => {          
          this.$router.push({
            name: "login",
            query: { info: "sessionFinished" }
          });
          this.$removeAuth();
        })
        .catch(error => {
          this.$makeToast(
            "Não foi possível encerrar sua sessão",
            "danger",
            "Saindo do sistema...",
            error
          );
        })
        .finally(() => {
          this.loginOut = false;
        });
    },
    MarkAllAsReaded() {
      this.Notifications.forEach(notification => {
        if (notification.IsRead == false) {
          notification.IsRead = true;
          sessionStorage.setItem("NotificationIsReaded", true);
        }
      });
    },
    ToggleDropdown(id) {
      this.$root.$emit("bv::toggle::collapse", id);
    }
  }
};
</script>

<style>
.user-avatar {
  vertical-align: bottom;
}
.no-select {
  user-select: none;
}
#imgUserNav {
  width: 40px;
  height: 40px;
}
.collapsing {
  transition: height 0.45s !important;
  display: block;
}
.user-name {
  font-weight: 600;
}
.company-name {
  font-size: 9pt;
  font-weight: 100;
}
.nav-link:hover {
  cursor: pointer;
}

/* IE11 Navbar flex fix. */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .navbar-nav {
    align-items: stretch !important;
    flex: 1 1 100%;
    flex-flow: row wrap;
  }

  .nav-item.notifications {
    margin-left: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/MainNavbar/NavbarNav.vue